import { useEffect, useState } from "react";
import autosize from "autosize";
import { useNavigate } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import BSNavbar from "../../component/Navbar/Navbar";
import CommentItem from "../../component/CommentItem/CommentItem";
import { Modal, Button } from "react-bootstrap";

const MyComment = () => {
  const navigate = useNavigate();
  const [myComment, setMyComment] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  const checkLoginStatus = async () => {
    try {
      await fetch(process.env.REACT_APP_API_URL + '/oauth/me', {
        method: 'POST',
        credentials: 'include'
      }).then(res => res.json());
    } catch {
      navigate('/home');
    }
  }

  const getMyComment = async () => {
    const response = await fetch(process.env.REACT_APP_API_URL + '/comments/me', {
      method: 'GET',
      credentials: 'include'
    }).then(res => res.json())

    if (response.length > 0) setMyComment(response);
    else setShow(true);
    setLoading(false);
  }

  useEffect(() => {
    const controller = new AbortController();

    setLoading(true);
    checkLoginStatus();
    getMyComment();
    autosize(document.querySelectorAll('textarea'));

    return () => controller.abort();
  }, [])

  if (loading) {
    return (
      <div style={{ background: '#dfd8cd', height: '100vh' }}>
        <BSNavbar bg={'#dfd8cd'} />
        <FadeLoader
          color="#4b3615"
          loading={true}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
          style={{ position: 'absolute', top: '50%', left: '50%' }}
        />
      </div>
    )
  } else {
    return (
      <div style={{ background: '#dfd8cd', minHeight: '100vh', paddingBottom: '20px' }}>
        <BSNavbar bg={'#dfd8cd'} />
        <Modal show={show}>
          <Modal.Header>
            <Modal.Title>Something wrong...</Modal.Title>
          </Modal.Header>
          <Modal.Body>還沒有心得，馬上寫一篇吧！</Modal.Body>
          <Modal.Footer>
            <Button variant="success" href='/new'>
              確認
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="mb-5"></div>
        {myComment.length > 0 &&
          myComment.map((ele, id) => (
            <CommentItem ele={ele} key={id} idx={id} variant='my-comment' />
          ))
        }
      </div>
    )
  }
}

export default MyComment;